class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.updateProductCount = this.updateProductCount.bind(this);
    this.initializeOpenAccordions();

    const facetForm = this.querySelector("form");
    if (facetForm) {
      // Listen to input changes on the form to update footer state

      facetForm.addEventListener("input", () => {
        const applyButton = facetForm.querySelector(".filter-apply-button");
        const viewButton = facetForm.querySelector("view-products-button");
        if (applyButton) applyButton.classList.remove("hidden");
        if (viewButton) viewButton.classList.add("hidden");
      });
    }
    facetForm.addEventListener("submit", (event) => {
      event.preventDefault();
      const searchParams = this.createSearchParams(event.target);
      this.onSubmitForm(searchParams, event);
      // After applying filters, hide Apply and show the View Products button
      const applyButton = event.target.querySelector(".filter-apply-button");
      const viewButton = event.target.querySelector("view-products-button");
      // if (applyButton) applyButton.classList.add("hidden");
      if (viewButton) viewButton.classList.remove("hidden");
    });

    // Create an event system to sync filter changes across components
    this.setupSyncEvents();
    const select = document.querySelector("#SortBy");
    select.addEventListener("click", (event) => {
      event.preventDefault();
      this.classList.add("select-is-showing");
    });
  }

  // Set up custom events for filter sync
  setupSyncEvents() {
    document.addEventListener("facetRemoved", (event) => {
      if (event.detail && event.detail.key && event.detail.value) {
        this.syncFilterRemoval(event.detail.key, event.detail.value);
      }
    });

    document.addEventListener("facetCleared", () => {
      this.syncFilterClearAll();
    });
  }

  // Sync filter removal across all filter forms
  syncFilterRemoval(key, value) {
    const forms = [
      "#FacetFiltersForm",
      "#FacetFiltersFormMobile",
      "#FacetFiltersPillsForm",
    ];

    forms.forEach((selector) => {
      const form = document.querySelector(selector);
      if (!form) return;

      const inputs = form.querySelectorAll(
        `input[name="${key}"][value="${value}"]`
      );
      inputs.forEach((input) => {
        input.checked = false;

        // Update label state
        const label = input.closest("label");
        if (label) label.classList.remove("active");

        // Check if parent details should be closed
        const details = input.closest("details");
        if (details) {
          const hasActiveInputs =
            details.querySelectorAll("input:checked").length > 0;
          if (!hasActiveInputs) details.open = false;
        }
      });
    });

    // Update all active facet displays
    this.syncActiveFacetsDisplay(key, value);
    this.updateFooterEmptyState();
  }

  // Sync active facets display
  syncActiveFacetsDisplay(key, value) {
    document
      .querySelectorAll(".active-facets facet-remove")
      .forEach((facetRemove) => {
        const link = facetRemove.querySelector("a");
        if (!link) return;

        try {
          const url = new URL(link.href, window.location.href);
          const params = url.searchParams;

          // Check if this facet-remove matches the key/value pair being removed
          if (params.has(key) && params.get(key) === value) {
            facetRemove.classList.add("is-removed");
            // Optionally remove from DOM
            facetRemove.remove();
          }
        } catch (error) {
          console.error("Error syncing active facets:", error);
        }
      });
  }

  // Sync clear all filters across all components
  syncFilterClearAll() {
    const forms = [
      "#FacetFiltersForm",
      "#FacetFiltersFormMobile",
      "#FacetFiltersPillsForm",
    ];

    forms.forEach((selector) => {
      const form = document.querySelector(selector);
      if (!form) return;

      // Clear checkboxes
      form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        input.checked = false;

        // Update label state
        const label = input.closest("label");
        if (label) label.classList.remove("active");
      });

      // Clear price range inputs
      form
        .querySelectorAll('price-range input[type="number"]')
        .forEach((input) => {
          input.value = "";
        });

      // Close all details
      form.querySelectorAll("details").forEach((details) => {
        details.open = false;
      });
    });

    // Clear all active facets displays
    document.querySelectorAll(".active-facets").forEach((container) => {
      if (container) container.innerHTML = "";
    });

    this.updateFooterEmptyState();
  }

  // Handle form input changes
  handleFormInputChange(event) {
    this.updateFooterEmptyState();
    this.updateProductCount(event);
  }
  // Update the updateFooterEmptyState method in your facet-filters-form component
  updateFooterEmptyState() {
    const footer = this.querySelector(".mobile-facets__footer");
    if (!footer) return;

    const form = this.querySelector("form");
    const activeFilters = form.querySelectorAll("input:checked");

    // Check for price range inputs with values
    const priceInputs = form.querySelectorAll(
      'price-range input[type="number"]'
    );
    const hasPriceFilter = Array.from(priceInputs).some(
      (input) => input.value !== ""
    );

    // Check if the cart is empty
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        if (
          (activeFilters.length === 0 && !hasPriceFilter) ||
          cart.item_count === 0
        ) {
          footer.classList.add("fade-out-fast"); // Apply a faster fade-out class

          const applyButton = footer.querySelector(".filter-apply-button");
          const viewButton = footer.querySelector(".button-view-products");
          const clearAllButton = footer.querySelector(
            ".active-facets__button-remove"
          );

          // if (applyButton) applyButton.classList.add("hidden");
          if (viewButton && viewButton.parentNode)
            viewButton.parentNode.classList.add("hidden");
          if (clearAllButton) clearAllButton.classList.add("hidden");
        } else {
          footer.classList.remove("fade-out", "fade-out-fast"); // Reset fade-out states

          const applyButton = footer.querySelector(".filter-apply-button");
          const viewButton = footer.querySelector(".button-view-products");
          const clearAllButton = footer.querySelector(
            ".active-facets__button-remove"
          );

          if (applyButton) applyButton.classList.remove("hidden");
          if (viewButton && viewButton.parentNode)
            viewButton.parentNode.classList.add("hidden");
          if (clearAllButton) clearAllButton.classList.remove("hidden");
        }
      })
      .catch((error) => console.error("Error checking cart state:", error));
  }

  initializeOpenAccordions() {
    const footer = this.querySelector(".mobile-facets__footer");

    // Open accordions for filters with active values
    this.querySelectorAll(".js-filter").forEach((details) => {
      const hasActiveValues = details.querySelector("[checked]");
      if (hasActiveValues) details.open = true;
      if (hasActiveValues) footer.classList.remove("fade-out");
    });
  }

  updateProductCount(event) {
    const form = event.target.closest("form");
    const searchParams = this.createSearchParams(form);
    this.fetchUpdatedCount(searchParams);
  }

  handleDrawerOpen() {
    this.initializeOpenAccordions();
    this.updateActiveFacetsDisplay();
  }

  async fetchUpdatedCount(searchParams) {
    const sections = this.constructor.getSections();
    try {
      const response = await fetch(
        `${window.location.pathname}?section_id=${sections[0].section}&${searchParams}`
      );
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, "text/html");
      // Update count displays
      const newCount = html.getElementById("ProductCount").innerHTML;
      document
        .querySelectorAll("#ProductCount, #ProductCountDesktop")
        .forEach((el) => {
          el.innerHTML = newCount;
        });
      // Update view button text
      const viewButton = document.querySelector(".button-view-products");
      if (viewButton) {
        const countMatch = newCount.match(/\d+/);
        viewButton.innerHTML = `View ${countMatch ? countMatch[0] : ""} Products`;
      }
    } catch (error) {
      console.error("Error updating product count:", error);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) {
      // Update empty state after URL hash change
      FacetFiltersForm.updateURLHash(searchParams);
      document.querySelectorAll("facet-filters-form").forEach((form) => {
        if (form.updateFooterEmptyState) form.updateFooterEmptyState();
      });
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
    // initializeSwatchHover();
    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });
    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );
    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }
        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;
      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );
        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);
        const isTextInput = event.target.getAttribute("type") === "text";
        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const currentElement = document.querySelector(selector);
      // Replace entire element to trigger DOM update
      currentElement.replaceWith(activeFacetsElement.cloneNode(true));
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];
    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });
    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");
    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }
    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");
    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }
    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");
    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");
    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    const productGrid = document.getElementById("product-grid");
    const sectionId = productGrid ? productGrid.dataset.id : "index";
    return [{ section: sectionId }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
      element.addEventListener("keydown", this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;
    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("data-min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("data-max", minInput.getAttribute("data-max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min"));
    const max = Number(input.getAttribute("data-max"));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

// class FacetRemove extends HTMLElement {
//   constructor() {
//     super();
//     const facetLink = this.querySelector('a');
//     facetLink.setAttribute('role', 'button');
//     facetLink.addEventListener('click', this.closeFilter.bind(this));
//     facetLink.addEventListener('keyup', (event) => {
//       event.preventDefault();
//       if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
//     });
//   }

//   closeFilter(event) {
//     event.preventDefault();
//     const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
//     form.onActiveFilterClick(event);
//   }
// }

// customElements.define('facet-remove', FacetRemove);


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");

    const handleRemove = (event) => {
      event.preventDefault();
      this.classList.add("is-removed");

      const facetFiltersForm = this.closest("facet-filters-form");
      const activeFacetsContainer = this.closest(".active-facets");
      const remainingFacets = activeFacetsContainer
        ? activeFacetsContainer.querySelectorAll(
            "facet-remove:not(.is-removed)"
          )
        : [];

      if (remainingFacets.length === 0) {
        if (facetFiltersForm) {
          // Update footer before rendering
          if (facetFiltersForm.updateFooterEmptyState) {
            facetFiltersForm.updateFooterEmptyState();
          }
          FacetFiltersForm.renderPage("");
        }
      } else {
        const url =
          event.currentTarget.href.indexOf("?") == -1
            ? ""
            : event.currentTarget.href.slice(
                event.currentTarget.href.indexOf("?") + 1
              );
        FacetFiltersForm.renderPage(url);
      }
    };

    facetLink.addEventListener("click", handleRemove);
    facetLink.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "SPACE") handleRemove(event);
    });
  }
}
customElements.define("facet-remove", FacetRemove);

function initializeSwatchHover() {
  const swatches = document.querySelectorAll(".swatch");
  swatches.forEach((swatch) => {
    swatch.addEventListener("mouseenter", showVariantImage);
    swatch.addEventListener("mouseleave", hideVariantImage);
  });
  function showVariantImage(event) {
    const swatch = event.currentTarget;
    const variantImageUrl = swatch.dataset.variantImage;
    if (!variantImageUrl) return;
    const mediaContainer = swatch
      .closest(".product-card-wrapper")
      .querySelector(".media--hover-effect");
    if (!mediaContainer) return;
    const variantImages = mediaContainer.querySelectorAll(".variant-image");
    variantImages.forEach((img) => {
      img.classList.remove("active");
      if (img.src === variantImageUrl) {
        img.classList.add("active");
      }
    });
    const mainImage = mediaContainer.querySelector(".main-product-image");
    if (mainImage) {
      mainImage.classList.remove("active");
    }
  }
  function hideVariantImage(event) {
    const mediaContainer = event.currentTarget
      .closest(".product-card-wrapper")
      .querySelector(".media--hover-effect");
    if (!mediaContainer) return;
    const variantImages = mediaContainer.querySelectorAll(".variant-image");
    variantImages.forEach((img) => {
      img.classList.remove("active");
    });
    const mainImage = mediaContainer.querySelector(".main-product-image");
    if (mainImage) {
      mainImage.classList.add("active");
    }
  }
}

class ViewProductsButton extends HTMLElement {
  constructor() {
    super();
    this.productCountElement = document.getElementById("ProductCount");
    this.button = this.querySelector(".button-view-products");
    if (this.button) {
      this.button.addEventListener("click", this.handleClick.bind(this));
    }
    this.initializeProductCountObserver();
  }

  initializeProductCountObserver() {
    if (this.productCountElement) {
      this.observer = new MutationObserver(() => this.updateButtonFromCount());
      this.observer.observe(this.productCountElement, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
    this.updateButtonFromCount(); // Initial update
  }

  updateButtonFromCount() {
    if (!this.productCountElement) return;
    const countText = this.productCountElement.textContent;
    const countMatch = countText.match(/\d+/);
    const count = countMatch ? parseInt(countMatch[0], 10) : 0;
    this.updateButtonText(count);
  }

  updateButtonText(count) {
    if (this.button) {
      this.button.innerHTML = `View ${count} Products`;
    }
  }

  // Remove handleFilterChange and related methods to rely on MutationObserver
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  // Existing handleClick method remains the same
  handleClick(e) {
    e.preventDefault();
    const facetForm = document.querySelector("facet-filters-form");
    if (facetForm) {
      facetForm.onSubmitHandler(e);
    }
    const drawer = this.closest("menu-drawer");
    if (drawer) {
      drawer.querySelector("summary").click();
    }
  }
}

customElements.define("view-products-button", ViewProductsButton);

class ActiveFacetsManager extends HTMLElement {
  constructor() {
    super();
    this.activeFacetsContainer = this.querySelector(".active-facets");
    this.removedFacets = new Set(); // Track removed facets
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Listen for changes on all facet forms
    document.querySelectorAll("facet-filters-form form").forEach((form) => {
      form.addEventListener("input", this.handleFilterChange.bind(this));
    });

    // Listen for price range changes
    document.querySelectorAll("price-range input").forEach((input) => {
      input.addEventListener("change", this.handleFilterChange.bind(this));
    });

    // Delegate click events for remove buttons with improved handling
    this.addEventListener("click", (event) => {
      const removeButton = event.target.closest(
        ".active-facet-remove, facet-remove"
      );
      if (removeButton) {
        event.preventDefault();
        const removeLink = removeButton.querySelector("a") || removeButton;
        // this.handleRemoveFilter(removeLink.href);
      }

      const clearAllButton = event.target.closest(
        ".active-facet-clear-link, .active-facets__button-remove"
      );
      if (clearAllButton) {
        event.preventDefault();
        this.handleClearAll(clearAllButton.href);
      }
    });
  }

  async handleFilterChange(event) {
    const form = event.target.closest("form");
    if (!form) return;

    const formData = new FormData(form);
    // Filter out any parameters that were previously removed
    const filteredFormData = new FormData();
    for (let [key, value] of formData.entries()) {
      if (!this.removedFacets.has(`${key}=${value}`)) {
        filteredFormData.append(key, value);
      }
    }
    
    const searchParams = new URLSearchParams(filteredFormData).toString();
    await this.updateFiltersAndURL(searchParams);
  }

  async handleRemoveFilter(url) {
    try {
      const parsedUrl = new URL(url, window.location.href);
      const searchParams = parsedUrl.searchParams;

      // Store the removed facet
      for (let [key, value] of searchParams.entries()) {
        this.removedFacets.add(`${key}=${value}`);

        // Uncheck corresponding checkboxes in all filter forms
        this.uncheckRelatedInputs(key, value);
      }

      // Remove the facet from DOM
      const facetElement = this.querySelector(
        `[href*="${searchParams.toString()}"]`
      )?.closest("facet-remove");
      if (facetElement) {
        facetElement.remove();
      }

      // Update URL and filters without the removed facet
      const currentParams = new URLSearchParams(window.location.search);
      for (let [key, value] of searchParams.entries()) {
        currentParams.delete(key);
      }

      await this.updateFiltersAndURL(currentParams.toString());
    } catch (error) {
      console.error("Error removing filter:", error);
    }
  }

  uncheckRelatedInputs(key, value) {
    // Find and uncheck inputs in all filter forms (desktop, mobile, and drawer)
    const formSelectors = [
      "#FacetFiltersForm",
      "#FacetFiltersFormMobile",
      "#FacetFiltersPillsForm",
    ];

    formSelectors.forEach((selector) => {
      const form = document.querySelector(selector);
      if (form) {
        // Find inputs by name and value
        const inputs = form.querySelectorAll(
          `input[name="${key}"][value="${value}"]`
        );
        inputs.forEach((input) => {
          input.checked = false;

          // If the input is inside a details element, update its state
          const detailsElement = input.closest("details");
          if (detailsElement) {
            const hasOtherCheckedInputs =
              detailsElement.querySelectorAll("input:checked").length > 0;
            if (!hasOtherCheckedInputs) {
              detailsElement.open = false;
            }
          }

          // Update any associated label styling
          const label = input.closest("label");
          if (label) {
            label.classList.remove("active");
          }
        });
      }
    });
  }

  async handleClearAll(url) {
    try {
      // Clear all active facets
      if (this.activeFacetsContainer) {
        this.activeFacetsContainer.innerHTML = "";
      }

      // Uncheck all checkboxes in filter forms
      const formSelectors = [
        "#FacetFiltersForm",
        "#FacetFiltersFormMobile",
        "#FacetFiltersPillsForm",
      ];

      formSelectors.forEach((selector) => {
        const form = document.querySelector(selector);
        if (form) {
          form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
            input.checked = false;

            // Update associated label styling
            const label = input.closest("label");
            if (label) {
              label.classList.remove("active");
            }
          });

          // Close all details elements
          form.querySelectorAll("details").forEach((details) => {
            details.open = false;
          });
        }
      });

      // Reset URL to base
      await this.updateFiltersAndURL("");
      // Clear the removed facets set
      this.removedFacets.clear();
    } catch (error) {
      console.error("Error clearing filters:", error);
    }
  }

  async updateFiltersAndURL(searchParams) {
    try {
      const response = await this.fetchUpdatedContent(searchParams);
      this.updateActiveFacets(response);

      // Update URL without page reload
      const newUrl = `${window.location.pathname}${searchParams ? `?${searchParams}` : ""}`;
      window.history.pushState({ path: newUrl }, "", newUrl);
      FacetFiltersForm.renderPage(searchParams);

      // Trigger facet refresh
      const facetFiltersForm = document.querySelector("facet-filters-form");
    } catch (error) {
      console.error("Error updating filters:", error);
    }
  }

  async fetchUpdatedContent(searchParams) {
    const url = `${window.location.pathname}?section_id=${this.dataset.sectionId}&${searchParams}`;
    const response = await fetch(url);
    const text = await response.text();
    return new DOMParser().parseFromString(text, "text/html");
  }

  updateActiveFacets(html) {
    const newActiveFacets = html.querySelector(".active-facets");
    if (!newActiveFacets) return;

    if (newActiveFacets.hasChildNodes()) {
      if (!this.activeFacetsContainer) {
        this.activeFacetsContainer = document.createElement("div");
        this.activeFacetsContainer.className = "active-facets";
        this.appendChild(this.activeFacetsContainer);
      }

      // Filter out removed facets from the new content
      const newContent = newActiveFacets.innerHTML;
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = newContent;

      Array.from(tempDiv.querySelectorAll("facet-remove")).forEach((facet) => {
        const link = facet.querySelector("a");
        if (
          link &&
          this.removedFacets.has(new URL(link.href).searchParams.toString())
        ) {
          facet.remove();
        }
      });

      this.activeFacetsContainer.innerHTML = tempDiv.innerHTML;
      this.activeFacetsContainer.style.display = "flex";
    } else {
      if (this.activeFacetsContainer) {
        this.activeFacetsContainer.style.display = "none";
      }
    }
  }
}

customElements.define("active-facets-manager", ActiveFacetsManager);
